export const API_KEY = {
    POST:`v1/account/forgetpassword`
}